const loginAndSignUp = {
  loginTips: "已經有HitPaw帳戶了？<1>登陸</1>",
  loginSuccessTips: "登入成功",
  loginErrorTips: "登入失敗",
  loginAccountOrPasswordErrorTips: "郵箱或密碼錯誤，請重新輸入",
  loginAccountNotExitErrorTips: "該郵箱未註冊",
  signUpTips: "還沒有註冊嗎？",
  rememberMe: "記住密碼",
  forgotPassword: "忘記密碼了？",
  forgotPasswordTitle: "忘記密碼",
  verifyEmailBtn: "驗證郵箱",
  resetPasswordTitle: "重置密碼",
  resetPasswordLabel: "請重新設置密碼",
  resetPasswordPlaceholder: "輸入新密碼",
  resetPasswordSuccessTips: "密碼重置成功",
  signUpPrivacyTips: "註冊即表示您同意我們的<1>使用服務</1>和<3>隱私政策</3>",
  loginPrivacyTips: "登入即表示您同意我們的<1>使用服務</1>和<3>隱私政策</3>",
  signUpSuccessTips: "您的帳戶已成功註冊！",
  getCode: "獲取驗證碼",
  getCodeSuccessTips: "已發送到您的郵箱，請查收",
  verificationSuccessTips: "郵箱驗證成功",
  surveyTitle: "歡迎來到HitPaw線上編輯",
  surveyStep1: "<1>第一步</1>",
  surveyStep2: "<1>第二步</1>",
  surveyStep3: "<1>第三步</1>",
  surveyQuestion: "你用HitPaw的目的是什麼？",
  surveyThemeQuestion: "選擇你喜歡的模式",
  surveyAnswerOther: "其他",
  surveyAnswer1: "日常影片",
  surveyAnswer2: "商業影片",
  surveyAnswer3: "企業影片",
  surveyAnswer4: "市場宣傳影片",
  surveyAnswer5: "社交媒體影片",
  surveyAnswer6: "幻燈片影片",
  surveyAnswer7: "影片工具",
  surveyAnswer8: "旅行影片",
  surveyAnswer9: "婚禮影片",
  surveyAnswer10: "生日影片",
  surveyAnswer11: "寶寶影片",
  surveyAnswer12: "動物影片",
  surveyAnswer13: "食物影片",
  surveyAnswer14: "時尚類影片",
  surveyAnswer15: "假日影片",
  surveyAnswer16: "運動影片",
  surveyAnswer17: "照片影片",
  surveyAnswer18: "音樂影片",
  surveyAnswerLightMode: "淺色模式",
  surveyAnswerDarkMode: "深色模式",
  surveyNextBtn: "繼續",
  surveyBackBtn: "返回",
  surveyDoneBtn: "完成",
  surveyStartBtn: "開始",
  logoutWarnTips: "您確定退出登錄嗎？",
};

export default loginAndSignUp;
